import React, { useCallback } from 'react';
import './SitePopupModal.css';
import { useSitePopup } from '../../context/RedirectContext';

function trackClarityEvent(name) {
  if (typeof window === 'undefined' || typeof window.clarity !== 'function') return;
  try {
    window.clarity('event', name);
  } catch {
    /* ignore analytics errors */
  }
}

export default function SitePopupModal() {
  const { popupModal, dismissSessionPopup, launchPopupShortlink } = useSitePopup();

  const onContinue = useCallback(() => {
    if (!popupModal?.redirectUrl) return;
    trackClarityEvent('shortlink_continue_click');
    launchPopupShortlink(popupModal.redirectUrl);
    dismissSessionPopup();
  }, [popupModal, launchPopupShortlink, dismissSessionPopup]);

  if (!popupModal) return null;

  const { title, message, redirectUrl } = popupModal;
  const showContinue = Boolean((redirectUrl || '').trim());

  return (
    <div
      className="hcva-popup-overlay"
      role="presentation"
      onMouseDown={(e) => {
        if (e.target === e.currentTarget) dismissSessionPopup();
      }}
    >
      <div
        className="hcva-popup-card"
        role="dialog"
        aria-modal="true"
        aria-labelledby="hcva-popup-title"
      >
        <button
          type="button"
          className="hcva-popup-close"
          aria-label="Dismiss notice"
          onClick={dismissSessionPopup}
        >
          ×
        </button>
        <h2 id="hcva-popup-title" className="hcva-popup-title">
          {title || 'Notice'}
        </h2>
        {message ? (
          <p className="hcva-popup-body">{message}</p>
        ) : (
          <p className="hcva-popup-body">&nbsp;</p>
        )}
        <div className="hcva-popup-actions">
          <button
            type="button"
            className="hcva-popup-continue"
            disabled={!showContinue}
            onClick={onContinue}
          >
            Continue
          </button>
        </div>
      </div>
    </div>
  );
}
